import { formatWithSign } from '@features/executive-report/utils/format-with-sign';
import { formatters } from '@utils/formattersV2';
import { PerformanceMetric } from '@features/executive-report/dimensions/content';
import { ImageWithMetadata } from '@features/powerpoint';
import { OverallLineItemTextsOptions } from './texts';

// TODO: Move this export; it is not used in full in this file
export type SalesDimensionsSlideBaseOptions = {
  recommendation: string;
  overallMetrics: Omit<OverallLineItemTextsOptions, 'index'>[];
  dimensionName: string;
  titleText: string;
  visible: boolean;
  subdimensions: {
    name: string;
    placeholder?: string;
    incrementalSalesLift: number | null;
    incrementalSales: number | null;
    impressions: number | null;
    image: ImageWithMetadata | null;
    totalSales?: number | null;
  }[];
};

export type PerformanceMetricsGetter = (
  subdimension: SalesDimensionsSlideBaseOptions['subdimensions'][number]
) => PerformanceMetric[];

export const dimensionMetrics = (
  subdimension: SalesDimensionsSlideBaseOptions['subdimensions'][number]
): PerformanceMetric[] => [
  {
    label: 'Sales Lift',
    value: formatWithSign(subdimension.incrementalSalesLift, value =>
      formatters.lift(value)
    ),
  },
  {
    label: 'Incremental Sales',
    value: formatters.currency(subdimension.incrementalSales, {
      full: true,
      decimals: 0,
    }),
  },
  {
    label: 'Impressions',
    value: formatters.impressions(subdimension.impressions, { full: true }),
  },
];

export const retailerMetrics = (
  subdimension: SalesDimensionsSlideBaseOptions['subdimensions'][number]
): PerformanceMetric[] => [
  {
    label: 'Total Sales',
    value: formatters.currency(subdimension.totalSales, {
      decimals: 1,
    }),
  },
  {
    label: 'Incremental Sales',
    value: formatters.currency(subdimension.incrementalSales, {
      full: true,
      decimals: 0,
    }),
  },
  {
    label: 'Sales Lift',
    value: formatWithSign(subdimension.incrementalSalesLift, value =>
      formatters.lift(value)
    ),
  },
];
